import {
	Component,
	OnInit,
	Output,
	EventEmitter,
	Input,
	OnChanges,
	SimpleChanges
} from '@angular/core';
import { getAddSectorForm } from './add-sector.element.component';
import { SectorsService } from 'projects/services/src/app/API/sectors.service';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { FORM_TYPE } from '../../types';
import { IDFormControl } from '../../d-form/d-form.helpers';
import { ActivatedRoute, Router } from '@angular/router';
import { CurrentUserService } from 'projects/services/src/app/current-user.service';

@Component({
	selector: 'app-add-sector-g',
	templateUrl: './add-sector.component.html',
	styleUrls: ['./add-sector.component.css']
})
export class AddSectorComponent implements OnInit, OnChanges {
	dataLoaded: boolean;
	addSectorForm: any;
	sectors: any;
	filteredSectors: any = [];
	loggedInUser: any;
	addSectorFormControl: IDFormControl;
	@Input() requiredFields = {
		supportingDocuments: true,
		affiliationCertificatesFromSSC: true,
	}
	@Input() maxTargetLimit;
	@Input() resetVersion = 0;
	// @Input() maxValue: number;
	@Input() version: number;
	@Input() type = FORM_TYPE.MODAL;
	@Input() label = {
		submit: '',
		cancel: ''
	};
	@Output() addSector = new EventEmitter();
	@Input() exceptSectors = [];
	constructor(private sectorService: SectorsService,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private currentUserService: CurrentUserService
	) { }

	ngOnInit() {
		this.loggedInUser = this.currentUserService.decodeToken();
		console.log(this.loggedInUser);

		const data = {
			isAddSector: true,
			schemeId: this.activatedRoute.snapshot.params.selectedSchemeId,
			tpId: this.loggedInUser.userName
		}
		console.log(this.activatedRoute);
		this.sectorService.getSectorForSelect(false, data).subscribe(sectors => {
			this.sectors = sectors;
			Helpers.copyArray(this.filteredSectors, sectors);
			this.removeAlreadySelectedSectors();
			// const requiredFields = {
			// 	supportingDocuments: true,
			// 	affiliationCertificatesFromSSC: true,
			// }
			const hideFields = {}
			let clearValidators;
			const url = this.router.url;
			const routeArr: any = url.split('/');
			if (routeArr.includes('update-scheme-form') || routeArr.includes('scheme-form')) {
				this.requiredFields = {
					supportingDocuments: false,
					affiliationCertificatesFromSSC: false,
				}
				Object.assign(hideFields, { hide: true });
				clearValidators = true;
			} else {
				Object.assign(hideFields, { hide: false });
			}
			this.addSectorForm = getAddSectorForm(
				{
					sectorOptions: this.filteredSectors,
					// sectorOptions: sectors,
					label: this.label,
					maxTargetLimit: this.maxTargetLimit
				},
				{
					uploadSupportingDocumentChange: this.onUploadSupportingDocumentChange.bind(
						this
					),
					sectorChange: (data) => {
						const sectorId = data.sectorID;
						if (sectorId) {
							this.sectorService.getSscDetails(sectorId)
								.subscribe(sscs => {
									sscs = sscs || [];
									sscs = sscs.length ? [sscs[0]] : [];
									const associatedSectorSkillCouncils = sscs.map(ssc => ssc.sscName).join(', ');
									this.addSectorFormControl.patchValues({ associatedSectorSkillCouncils });
									if (clearValidators === true) {
										this.addSectorForm.forms[0].formRef.get('affiliationCertificatesFromSSC').clearValidators();
										this.addSectorForm.forms[0].formRef.get('affiliationCertificatesFromSSC').updateValueAndValidity();
										this.addSectorForm.forms[0].formRef.get('supportingDocuments').clearValidators();
										this.addSectorForm.forms[0].formRef.get('supportingDocuments').updateValueAndValidity();
										this.addSectorForm.forms[0].formRef.get('workOrder').clearValidators();
										this.addSectorForm.forms[0].formRef.get('workOrder').updateValueAndValidity();
										this.addSectorForm.forms[0].formRef.get('challanOfFeePaid').clearValidators();
										this.addSectorForm.forms[0].formRef.get('challanOfFeePaid').updateValueAndValidity();
									}
								});
						} else {
							console.warn('Sector Id Not')
						}
					}
				},
				Object.assign({}, this.requiredFields),
				hideFields
			);
			this.dataLoaded = true;
		});
	}

	removeAlreadySelectedSectors() {
		const selectedSectors = {};
		this.exceptSectors.map(sector => {
			selectedSectors[sector.name] = true;
		});
		this.sectors = this.sectors || [];
		const filteredSectors = this.sectors.filter(sector => {
			return selectedSectors[sector.name] ? false : true;
		});
		Helpers.copyArray(this.filteredSectors, filteredSectors);
		// Helpers.copyArray(this.sectors, filterdSectors);
	}
	ngOnChanges(changes: SimpleChanges) {
		if (changes && changes.version) {
			console.log('version changed, ', this.sectors);
			this.removeAlreadySelectedSectors();
		}
	}

	onSectorAdd(data) {
		this.dataLoaded = false;
		console.log(data);
		this.addSector.emit(data);
		this.dataLoaded = true;
	}

	onUploadSupportingDocumentChange(data) {
		console.log(data);
	}
}
